import { MapPin } from 'lucide-react';
import { FullScreenShell } from '../ui/FullScreenShell';

interface AdminDetalleModalProps {
  readonly isOpen: boolean;
  readonly lumisialNombre: string;
  readonly lumisialCiudad: string;
  readonly diocesisNombre: string;
  readonly provinciaNombre: string;
  readonly onClose: () => void;
  readonly children: React.ReactNode;
}

export function AdminDetalleModal({
  isOpen,
  lumisialNombre,
  lumisialCiudad,
  diocesisNombre,
  provinciaNombre,
  onClose,
  children,
}: AdminDetalleModalProps) {
  const header = (
    <div className="sticky top-0 z-10 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
      <div>
        <div className="flex items-center gap-1.5 text-xs text-gray-400 mb-1">
          <MapPin className="w-3 h-3" />
          <span>{provinciaNombre}</span>
          <span>/</span>
          <span>{diocesisNombre}</span>
          <span>/</span>
          <span className="font-medium text-gray-600">{lumisialNombre}</span>
          {lumisialCiudad && <span className="text-gray-400">— {lumisialCiudad}</span>}
        </div>
        <p className="text-xs text-amber-600 font-medium">Vista de solo lectura</p>
      </div>
    </div>
  );

  return (
    <FullScreenShell
      isOpen={isOpen}
      onClose={onClose}
      header={header}
      variant="fullpage"
      showCloseButton={true}
    >
      <div className="p-4 md:p-6">
        {children}
      </div>
    </FullScreenShell>
  );
}
